import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "widget-tab d-flex vertical widget-header-background" }
const _hoisted_2 = {
  key: 0,
  class: "font-weight-bold"
}

import {ComponentPublicInstance, computed, ref} from 'vue';
import WidgetHeader from "~/chat/vue/widget/WidgetHeader.vue";
import WindowHelper from "~/ts/library/WindowHelper";
import {IWidgetTab} from "~/chat/vue/widget/IWidgetTab";
import ChatScrollContainer from "~/chat/vue/misc/ChatScrollContainer.vue";


const __default__ = {
    name: "WidgetTab"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    closeHandler: {},
    back: { type: Boolean, default: true },
    title: {},
    contentTab: { type: Boolean },
    withoutPadding: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

let props = __props;

let overflow = computed(() => {
    return !!props.contentTab;
});

let padding = computed(() => {
    return !!overflow.value;
});

let content = ref<ComponentPublicInstance>()

function scrollTo(y: number) {
    WindowHelper.scrollTo(y, content.value.$el);
}

__expose<IWidgetTab>({
    scrollTo
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WidgetHeader, {
      back: _ctx.back,
      "close-handler": _ctx.closeHandler
    }, {
      default: _withCtx(() => [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "header")
      ]),
      _: 3
    }, 8, ["back", "close-handler"]),
    _createVNode(ChatScrollContainer, {
      enabled: _unref(overflow),
      class: _normalizeClass({
                'widget-tab-content': true,
                'filler': true,
                'widget-content-padding': _unref(padding),
                'content-border-radius-top': true,
                'content-border-radius-bottom': true,
                'without-padding': !!_ctx.withoutPadding,
                'content-background': true
            }),
      ref_key: "content",
      ref: content
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "content")
      ]),
      _: 3
    }, 8, ["enabled", "class"]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})